define(function(require, exports, module) {
    'use strict';
    var UserModel = require('modules/user/codere-theme/user.model');
    module.exports = new UserModel();
});
